import { useQuery } from '@tanstack/react-query';

import { useRequest, getAnalyticsSettingsKey } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  AnalyticsSettingsData,
  UseAnalyticsSettingsParams,
  AnalyticsSettingsQueryKey,
} from './types';

export const useAnalyticsSettings: QueryFunction<
  AnalyticsSettingsData,
  [UseAnalyticsSettingsParams],
  AnalyticsSettingsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getAnalyticsSettingsKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/analytics_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
